export class SwaggerSecurity {
  public api_key: any[];
}
